import { Injectable } from '@angular/core';
import { ShardHandlerService } from '../sharding/shard-handler.service';
import * as labels from './label.db.json';


@Injectable({
  providedIn: 'root'
})
export class LabelsService {

  constructor(private shardHandler : ShardHandlerService) { }

  public get(id){
    // Get shard
    let shard = this.shardHandler.getAlias();
    let label = labels['labels'][id] || "";

    if(labels[shard] != null && labels[shard][id] != null){
      label = labels[shard][id];
    }

    return label;
  }
}

